import '@/assets/styles/cart-order.css'

import { ArrowLeft, ArrowRight, ChevronsUpDown, Trash2, Eye, EyeOff } from 'lucide-react'
import { BsCartXFill } from 'react-icons/bs'
import { FaFileExcel } from 'react-icons/fa'
import ReactPaginate from 'react-paginate'

import { ProductCardStatusComponent } from '@/modules/product/components/product-card-status.component'
import { ProductCardContainer } from '@/modules/product/containers/product-card.container'
import { FabComponent } from '@/modules/shared/components/fab.component'
import { InputFormComponent } from '@/modules/shared/components/input-form.component'
import { Button } from '@/modules/shared/components/ui/button'
import { Checkbox } from '@/modules/shared/components/ui/checkbox'
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from '@/modules/shared/components/ui/collapsible'
import { Form } from '@/modules/shared/components/ui/form'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/modules/shared/components/ui/tooltip'
import { numberFormatter } from '@/modules/shared/utils/formatter'

import { useCart } from './use-cart.hook'
import { useOrderFormStore } from '../../stores/order-form.store'
import { cn } from '@/modules/shared/lib/utils'
import { getTextColorLL } from '@/modules/product/utils/get-text-color-ll.util'
import { useState } from 'react'

export function CartComponent() {

	const {
		currentItems,
		form,
		handleChangePageOfPagination,
		handleChangeValues,
		handleModalLoadExcel,
		isShowButtonLoadExcel,
		handleClearCart,
		isShowFormDiscount,
		isViewOrder,
		pageCount,
		selectedItems,
		handleChangeCheckBox,
		renderDefaultFieldsOfDiscount,
		handleRemoveManyItems,
	} = useCart()

	const [showDiscount, setShowDiscount] = useState(false)
	const isWideVersion = window.innerWidth > 1024

	const { paramsLayoutOrderForm, jsonOrderForm } = useOrderFormStore()

	const fieldHeader = paramsLayoutOrderForm?.geral?.find(
		(item) => item.campo === 'field2',
	)

	return (
		<div className="flex flex-1 flex-col">
			<Form {...form}>
				{isShowFormDiscount && (
					<div className="flex gap-1 flex-1 justify-between">
						{renderDefaultFieldsOfDiscount?.map(
							(item, index) =>
								item.visible && (
									<InputFormComponent
										key={item.id}
										inputMode="numeric"
										type="number"
										control={form.control}
										name={item.campo}
										label={item.label}
										disabled={isViewOrder || !item.enabled}
										onKeyUp={(e) =>
											handleChangeValues(item.fieldJson, e.currentTarget.value)
										}
									/>
								),
						)}
					</div>
				)}

				{!isViewOrder && (
					<div>
						{isShowButtonLoadExcel && selectedItems.length === 0 ? (
							<>
								<FabComponent
									className="bottom-24 md:bottom-3"
									items={[
										{
											icon: FaFileExcel,
											type: 'excel',
											id: '1',
											label: 'Importar Excel',
											disabled: false,
											action: handleModalLoadExcel,
										},
										{
											icon: BsCartXFill,
											type: 'remove',
											id: '2',
											label: 'Limpar carrinho',
											disabled: currentItems.length === 0,
											action: handleClearCart,
										},
									]}
									action={() => { }}
								/>
							</>
						) : (
							<TooltipProvider>
								<Tooltip>
									<TooltipTrigger asChild>
										<Button
											className="bg-black/80 p-2 h-14 w-14 rounded-full fixed bottom-24 md:bottom-2 right-2 z-50 shadow-lg mb-1 border-0 hover:bg-black/90 flex justify-center items-center cursor-pointer"
											variant="outline"
											onClick={handleRemoveManyItems}
											disabled={selectedItems.length === 0}
										>
											<Trash2 color="white" size={20} />
										</Button>
									</TooltipTrigger>
									<TooltipContent side="left">
										<p>Remover itens selecionados</p>
									</TooltipContent>
								</Tooltip>
							</TooltipProvider>
						)}
					</div>
				)}
			</Form>

			{currentItems.length > 0 && (
				<div className="mb-2 flex justify-end items-center gap-2">
					<span className="text-xs text-gray-500">Visualizar descontos</span>
					<Button
						onClick={() => setShowDiscount(!showDiscount)}
						className="h-6 w-6 p-0 bg-gray-100 hover:bg-gray-200 border-0 rounded-full flex items-center justify-center"
						type="button"
						title={showDiscount ? 'Ocultar Descontos' : 'Exibir Descontos'}
					>
						{showDiscount ? <EyeOff size={12} className="text-gray-600" /> : <Eye size={12} className="text-gray-600" />}
					</Button>
				</div>
			)}

			<div className="min-h-[45vh] mt-2">
				<div className="mb-4">
					{currentItems.length > 0 ? (
						currentItems.map((item) => (
							<Collapsible
								key={item.idPedidoCel}
								className="border rounded-node mb-2 cursor-pointer px-2 md:px-3 py-2 flex-1"
							>
								<div className="flex items-center">
									{!isViewOrder && (
										<div className="mr-3">
											<Checkbox
												checked={selectedItems.includes(item.fkProduto)}
												onCheckedChange={() =>
													handleChangeCheckBox(item.fkProduto)
												}
											/>
										</div>
									)}

									<CollapsibleTrigger asChild>
										<div className="flex items-center text-sm flex-1 fle">
											<div className="flex flex-col w-full">
												<div className="w-full justify-between flex">
													<p className="overflow-hidden text-xs font-semibold">
														{item.produto?.referenciaAfere} -{' '}
														{item.produto?.descricao}
													</p>
												</div>

												<div className="flex flex-col text-[11px] md:text-[12px] gap-1 flex-1">
													<div className="flex flex-wrap items-center w-full gap-x-1">
														<span>{item.valorUnitario}</span>
														<span>X</span>
														<span>{item.quantidade}</span>
														<span>=</span>
														<span className="font-medium">
															{numberFormatter.format(item.valorUnitario * item.quantidade)}
														</span>
														<span>+</span>
														<span>ST:</span>
														<span className="font-medium">
															{numberFormatter.format(item.vIcmsSt)}
														</span>
														<span>+</span>
														<span>IPI:</span>
														<span className="font-medium">
															{numberFormatter.format(item.vIpi)}
														</span>
														<span>=</span>
														<span className="text-xs font-bold text-nowrap">
															{numberFormatter.format(item.valorTotalItem)}
														</span>
													</div>
													{showDiscount && item.porcDescontoTabela > 0 && (
														<div className="flex items-center">
															<div className="px-1.5 py-0.5 bg-red-50 text-red-500 border-red-300 rounded text-[10px] md:text-xs">
																<span className=" font-medium">
																	Desc: {item.porcDescontoTabela}%
																</span>
															</div>
														</div>
													)}
												</div>
											</div>

											<div className="flex-1 items-center justify-between flex">
												<div className="space-x-0 space-y-0 flex flex-col md:flex-row mr-1 md:mr-4">

													{fieldHeader?.fieldName === 'j_Plucro' ? (
														<p className={cn('text-sm w-full font-medium', getTextColorLL(item.statusLl))}>
															{
																item?.j_Plucro
															}
														</p>
													) : (
														<ProductCardStatusComponent
															statusType={item.statusLl}
														/>
													)}

												</div>

											</div>
										</div>
									</CollapsibleTrigger>
								</div>

								<CollapsibleContent className="pb-4 mr-3">
									<ProductCardContainer isCalculatingOrder={false} hasOneProduct={false} inputSearchRef={null} product={item} quantityRef={null} />
								</CollapsibleContent>
							</Collapsible>
						))
					) : (
						<div className="flex justify-center w-full min-h-[45vh] items-center mt-10 text-gray-500">
							<p>Nenhum item no carrinho</p>
						</div>
					)}
				</div>

				{pageCount > 1 && (
					<ReactPaginate
						breakLabel="..."
						nextLabel={<ArrowRight size={20} />}
						onPageChange={handleChangePageOfPagination}
						pageRangeDisplayed={5}
						pageCount={pageCount}
						previousLabel={<ArrowLeft size={20} />}
						renderOnZeroPageCount={null}
						pageClassName="list-group"
						pageLinkClassName="list-group-item"
						nextLinkClassName="next-button"
						previousLinkClassName="previous-button"
						containerClassName="container-pagination"
					/>
				)}
			</div>
		</div>
	)
}
